module.exports = __webpack_public_path__ + "media/reju5.7c9a42e9.mp4";